import React from "react";
import AppConstants from "../constants/AppConstants";
import mobileOverlay from "../../assets/img/overlay-helper-mobile-vertical.svg";
import When from "./utils/When";

const PreviewPanel = ({ selectedLayout, url }) => {
  const wrapperStyle = {
    flex: "1 1 auto",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    position: "absolute",
  };
  let frameStyle = {};
  if (selectedLayout == AppConstants.LAYOUT_DESKTOP) {
    frameStyle = {
      border: 0,
      width: "100%",
      flex: "1 1 auto",
      display: "block",
      height: "100%",
    };
  } else if (selectedLayout == AppConstants.LAYOUT_MOBILE) {
    frameStyle = {
      border: 0,
      width: "335px",
      display: "block",
      margin: "0 auto",
      height: "650px",
      position: "relative",
      zIndex: 200,
      marginTop: "28px",
    };
  }

  return (
    <div className={"preview-panel preview-panel-" + selectedLayout} style={wrapperStyle}>
      <When it={selectedLayout === AppConstants.LAYOUT_MOBILE}>
        <img className="preview-panel-mobile-bg" src={mobileOverlay} alt="Mobile phone overlay" />
      </When>
      <iframe src={url} width="100%" height="100" style={frameStyle}></iframe>
    </div>
  );
};

export default PreviewPanel;
